module.exports = __webpack_public_path__ + "static/media/Team 35 - The Hive.7209dd47.png";